export enum InsuranceDataEnum {

  YOUNGEST_DRIVER_AGE = 'youngestDriverAge',
  START_INSURANCE_DATE = 'startInsuranceDate',
  END_INSURANCE_DATE = 'endInsuranceDate',
}
